
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/powerforall",
      function () {
        return require("private-next-pages/powerforall/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/powerforall"])
      });
    }
  